<template>

  <button type="button" @click="scrollTo(scrollTrigger)" @mouseleave="hoverHandler().leave" @mouseover="hoverHandler().over" style="box-shadow: 0 -4px 0 #c7642d inset;" class="bg-orangebtn text-white lg:leading-[76px] font-ww-medium lg:text-51 md:text-4xl text-xl md:px-3 md:py-2 py-4 text-center w-full block rounded uppercase btn-cta-custom"
  :class="devMode && 'split-test-outline'" :data-event-label="dataAttrs['data-event-label']" :data-event-action="dataAttrs['data-event-action']" :data-event-name="dataAttrs['data-event-name']">
   {{renderText}}
  </button>

</template>

<script setup>
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
  dataAttrs: {
      type: Object,
      default: () => ({})
  },
  scrollTrigger: {
    type: String
  }
})

const renderText = ref(props.text)
const expDetails = props.dataAttrs['data-event-label'] || null
const devMode = useCookie('devMode')

const hoverHandler = () => ({
  leave: () => {
    if (devMode.value && expDetails) {
      renderText.value = props.text
    }

  },
  over: () => {
    if (devMode.value && expDetails) {
      renderText.value = expDetails
    }
  }
} )
</script>
